import { render, staticRenderFns } from "./FooterAltGDN.vue?vue&type=template&id=2e7047ca"
import script from "./FooterAltGDN.vue?vue&type=script&lang=js"
export * from "./FooterAltGDN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7047ca')) {
      api.createRecord('2e7047ca', component.options)
    } else {
      api.reload('2e7047ca', component.options)
    }
    module.hot.accept("./FooterAltGDN.vue?vue&type=template&id=2e7047ca", function () {
      api.rerender('2e7047ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/FooterAltGDN.vue"
export default component.exports